/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon24Solid = forwardRef('BuildingHomeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m8.973 2.752-7.876 7.16C.285 10.65.807 12 1.904 12H4v6a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-6h2.096c1.097 0 1.619-1.35.807-2.088l-7.876-7.16a4.5 4.5 0 0 0-6.054 0Z" })));
});
